import Input, { IInput } from '../..';

import React from 'react';

export const CellphoneInput = React.forwardRef((props: IInput, ref) => {
  return (
    <Input
      {...props}
      mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      ref={ref}
    />
  );
});

CellphoneInput.displayName = 'CellphoneInput';
export default CellphoneInput;
